import {
  Component,
  DestroyRef,
  inject,
  input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { OperationsSummaryDashboard } from 'src/app/core/models/operations/operations-summary-dashboard.model';
import {
  RouteSummary,
  RouteSummaryResponse,
} from 'src/app/core/models/operations/operations-summary.model';
import { SummmaryDashboardColumnHeaders } from './summary-dashboard.constants';
@Component({
  selector: 'app-summary-dashboard',
  templateUrl: './summary-dashboard.component.html',
  styleUrls: ['./summary-dashboard.component.scss'],
  standalone: false,
})
export class SummaryDashboardComponent implements OnInit, OnChanges {
  summaryData$ = input<Observable<RouteSummaryResponse>>();
  destroy = inject(DestroyRef);

  readonly HEADERS = SummmaryDashboardColumnHeaders;

  dataSource = new MatTableDataSource<OperationsSummaryDashboard>();
  totalDeliveryStops = 0;
  completedDeliveryStops = 0;
  pendingDeliveryStops = 0;
  totalPickupStops = 0;
  completedPickupStops = 0;
  pendingPickupStops = 0;
  totalDeliveryVolume = 0;
  completedDeliveryVolume = 0;
  pendingDeliveryVolume = 0;
  totalPickupVolume = 0;
  completedPickupVolume = 0;
  pendingPickupVolume = 0;

  ngOnInit() {
    this.clearTheTable();
    this.summaryData$()?.subscribe((data) => {
      this.convertDataForSummary(data.response.routesummary);
    });
    this.dataSource = new MatTableDataSource();
  }

  clearTheTable() {
    this.totalDeliveryStops = 0;
    this.completedDeliveryStops = 0;
    this.pendingDeliveryStops = 0;
    this.totalPickupStops = 0;
    this.completedPickupStops = 0;
    this.pendingPickupStops = 0;
    this.totalDeliveryVolume = 0;
    this.completedDeliveryVolume = 0;
    this.pendingDeliveryVolume = 0;
    this.totalPickupVolume = 0;
    this.completedPickupVolume = 0;
    this.pendingPickupVolume = 0;
  }

  convertDataForSummary(data: RouteSummary[]) {
    data.forEach((d) => {
      this.getAllStops(d);
      this.getAllVolume(d);
    });
  }

  getAllStops(d: RouteSummary) {
    // get total delivery stops
    if (d.deliveryStops?.total) {
      this.totalDeliveryStops += d.deliveryStops.total;
    }

    // get completed delivery stops
    if (d.deliveryStops?.completed) {
      this.completedDeliveryStops += d.deliveryStops.completed;
    }

    // get pending delivery stops
    if (d.deliveryStops?.pending) {
      this.pendingDeliveryStops += d.deliveryStops.pending;
    }

    // get total pickup stops
    if (d.pickupStops?.total) {
      this.totalPickupStops += d.pickupStops.total;
    }

    // get completed pickup stops
    if (d.pickupStops?.completed) {
      this.completedPickupStops += d.pickupStops.completed;
    }

    // get pending pickup stops
    if (d.pickupStops?.pending) {
      this.pendingPickupStops += d.pickupStops.pending;
    }
  }

  getAllVolume(d: RouteSummary) {
    // get total delivery volume
    if (d?.deliveryVolume?.total) {
      this.totalDeliveryVolume += d.deliveryVolume.total;
    }

    // get completed delivery volume
    if (d?.deliveryVolume?.completed) {
      this.completedDeliveryVolume += d.deliveryVolume.completed;
    }

    // get total delivery volume
    if (d?.deliveryVolume?.pending) {
      this.pendingDeliveryVolume += d.deliveryVolume.pending;
    }

    // get total pickup volume
    if (d?.pickupVolume?.total) {
      this.totalPickupVolume += d.pickupVolume.total;
    }

    // get completed pickup volume
    if (d?.pickupVolume?.completed) {
      this.completedPickupVolume += d.pickupVolume.completed;
    }

    // get pending pickup volume
    if (d?.pickupVolume?.pending) {
      this.pendingPickupVolume += d.pickupVolume.pending;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.clearTheTable();
    const changedSummaryData = changes.summaryData$.currentValue;
    if (changedSummaryData) {
      changedSummaryData
        .pipe(
          takeUntilDestroyed(this.destroy),
          map((data: RouteSummaryResponse) => {
            this.convertDataForSummary(data.response.routesummary);
          }),
        )
        .subscribe();
    }
  }
}
